export default __webpack_public_path__ + "static/media/6.efd1286f.jpg";